import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isVideoAccountAndDimension } from '../../../../../config/report-predicates/isVideoAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { QUARTILE } from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import { QUARTILE_VIDEO_REPORT_ID } from './quartileVideoReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const quartileVideoReportConfig = {
    id: QUARTILE_VIDEO_REPORT_ID,
    label: 'Quartile',
    permissions: [[REPORT_PERMISSION.ADS_CONSOLE_QUARTILE_REPORT], REPORT_PERMISSION.ADS_CONSOLE_VIDEO_CAMPAIGNS],
    accountConfigurations: { [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false' },
    visibilityCondition: isVideoAccountAndDimension,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-quartile',
    rowIdField: QUARTILE.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    searchPlaceholderMsgId: 'app.reports.byQuartile.search.placeholder',
    searchField: QUARTILE.field,
    filters: [
        { id: FILTER_TYPE.COUNTRY },
        { id: FILTER_TYPE.PLATFORM },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.SALES_PERSON,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER_GROUP,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.SALES_GROUP,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
    ],
};

export default quartileVideoReportConfig;
